const timeIcon = require('@/assets/images/filterIcon/time.png')
const countryIcon = require('@/assets/images/filterIcon/country.png')
const dealIcon = require('@/assets/images/filterIcon/dealType.png')
const resultIcon = require('@/assets/images/filterIcon/resultType.png')
const priceIcon = require('@/assets/images/filterIcon/price.png')

module.exports = {
  timeIcon,
  countryIcon,
  dealIcon,
  resultIcon,
  priceIcon
}